<template>
  <div>
    <!-- Viewing orders -->
    <v-toolbar flat color="white" v-if="async">
      <v-divider class="mx-2" inset vertical></v-divider>
      <!-- Filter inputs -->
      <v-flex xs6 md2>
        <v-text-field
          append-icon="search"
          single-line
          hide-details
          clearable
          v-model="filter"
          :label="$t('orders_crud.filter')"
          autofocus
          @input="isChangingFilter = true"
        ></v-text-field>
      </v-flex>

      <v-flex xs6 md2>
        <v-text-field
          prepend-icon="event"
          single-line
          readonly
          hide-details
          clearable
          v-model="deliveryDateFrom"
          :label="$t('orders_crud.delivery_date_from')"
          @click="changeDate($event, 'deliveryDateFrom')"
        ></v-text-field>
      </v-flex>

      <v-flex xs6 md2>
        <v-text-field
          prepend-icon="event"
          single-line
          hide-details
          clearable
          v-model="deliveryDateTo"
          :label="$t('orders_crud.delivery_date_to')"
          @click="changeDate($event, 'deliveryDateTo')"
        ></v-text-field>
      </v-flex>

      <v-flex xs24 md8>
        <!-- status selector -->
        <status-selector
          :from="statusFrom"
          :to="statusTo"
          :table="'orders'"
          :language="this.$router.currentRoute.params.lang.toUpperCase()"
          @statusesChanged="changeStatusFilters"
        />
      </v-flex>

      <v-flex xs6 md2>
        <v-select
          v-model="pagination.rowsPerPage"
          :items="perPage"
          :label="$t('orders_crud.element_count')"
          prepend-icon="pageview"
          hide-details
          @input="savePerPage"
        ></v-select>
      </v-flex>
      <v-flex xs6 md2 v-if="user.company_id == 7">
        <v-text-field
          @input="isChangingWeek = true"
          v-model="week"
          append-icon="next_week"
          single-line
          hide-details
          clearable
          :label="$t('orders_crud.week')"
        ></v-text-field>
      </v-flex>

      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn
            v-if="user.type != 6"
            color="primary"
            dark
            class="mb-2"
            v-on="on"
          >
            {{ $t("orders_crud.new_order") }}
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.offer_id"
                    :label="$t('orders_crud.offer_id')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.production_id"
                    :label="$t('orders_crud.production_id')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    type="date"
                    v-model="editedItem.delivery_date"
                    :label="$t('orders_crud.delivery_date')"
                  ></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    type="text"
                    v-model="editedItem.customer_order_number"
                    :label="$t('orders_crud.customer_order_number')"
                  ></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    type="text"
                    v-model="editedItem.manager_email"
                    :label="$t('orders_crud.manager_email')"
                  ></v-text-field>
                </v-flex>
                <v-flex>
                  <customer-select
                    ref="customerSelect"
                    v-if="isAdmin"
                    @customerSelected="setCustomer"
                    @contactSelected="setContact"
                    @addressSelected="setAddress"
                  ></customer-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">
              {{ $t("orders_crud.cancel") }}
            </v-btn>
            <v-btn color="blue darken-1" v-if="!formType" flat @click="edit">
              {{ $t("orders_crud.edit") }}
            </v-btn>
            <v-btn color="blue darken-1" v-if="formType" flat @click="save">
              {{ $t("orders_crud.save") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-btn
        color="primary"
        :disabled="ordersSelected"
        @click="planDispatchForOrders"
      >
        <v-icon>local_shipping</v-icon>
      </v-btn>
      <v-btn
        color="primary"
        v-if="user.type != 6"
        :disabled="ordersSelected"
        @click="openOperationsMaker"
        >Į gamybą</v-btn
      >
      <v-btn
        color="primary"
        v-if="user.type != 6"
        :disabled="ordersSelected"
        @click="deleteOrders"
      >
        <v-icon>delete</v-icon>
      </v-btn>
    </v-toolbar>

    <div class="table-wrapper">
      <div class="progress-wrapper">
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
      </div>
      <div class="rTable">
        <div class="rTableRow problem-header">
          <div class="rTableHead" :style="{ width: 2 + '%' }">
            <input
              id="orders-checkbox"
              type="checkbox"
              @click="selectAllOrders($event)"
            />
          </div>
          <div
            class="rTableHead"
            v-for="(header, i) in headers"
            :key="i"
            :style="{ width: header.width + '%' }"
          >
            <span
              :class="{ clickable: header.sortable }"
              @click="changeSortBy(header)"
              >{{ header.text }}</span
            >
            <span v-if="header.sortable && pagination.sortBy == header.value">
              <v-icon small v-if="!pagination.descending">north</v-icon>
              <v-icon small v-else>south</v-icon>
            </span>
          </div>
        </div>
        <div class="rTableRow" v-for="(order, i) in orders" :key="i">
          <div class="rTableCell">
            <input
              class="order-checkbox"
              type="checkbox"
              @click="selectOrder($event, order)"
            />
          </div>
          <div class="rTableCell">
            <a @click="openProducts(order.id)">{{ getOrderText(order.production_id) }}</a>
          </div>
          <div class="rTableCell">{{ getOrderText(order.offer_id) }}</div>
          <div class="rTableCell">{{ order.customer }}</div>
          <div class="rTableCell" v-if="user.company_id != 7">
            {{ order.delivery_date }}
          </div>
          <div class="rTableCell" v-else>{{ order.getWeekText() }}</div>
          <div class="rTableCell">{{ order.product_type }}</div>
          <div class="rTableCell number-cell">{{ order.count }}</div>
          <div class="rTableCell number-cell">{{ roundArea(order.area) }}</div>
          <div class="rTableCell">{{ order.customer_order_number }}</div>
          <div class="rTableCell">{{ order.manager_email }}</div>
          <div class="rTableCell">
            <change-status-to
              v-if="async"
              @statusChanged="initialize"
              :id="order.id"
              :statusNames="statusNames"
              :statusRights="statusRights"
              :user="user"
              :currentStatus="order.status"
              :table="'orders'"
            />
          </div>
          <div class="rTableCell" v-if="user.company_id == 7">
            {{ order.address }}
          </div>
          <div class="rTableCell">
            <v-icon
              class="mr-2"
              v-tooltip="$t('orders_crud.plan_dispatch')"
              @click="planDispatch(order)"
              small
              >local_shipping</v-icon
            >

            <v-icon
              v-if="user.type != 6"
              small
              class="mr-2"
              @click="editItem(order)"
              v-tooltip="$t('orders_crud.edit')"
              >edit</v-icon
            >
            <status-changes
              class="mr-2"
              :item="order"
              :table="'order'"
              v-tooltip="$t('orders_crud.view_changes')"
            ></status-changes>
            <v-icon
              v-if="user.type != 6"
              small
              class="mr-2"
              @click="deleteOrder(order)"
              v-tooltip="$t('orders_crud.delete')"
              >delete</v-icon
            >
          </div>
        </div>
      </div>
    </div>
    <div class="text-xs-center" v-if="async">
      <v-pagination
        @input="paginate"
        v-model="page"
        :length="pages"
      ></v-pagination>
    </div>
    <OrderOperationsMaker ref="orderOperationsMaker" @saved="productionSaved" />
    <DatePicker ref="datePicker" @dateSelected="selectDate" />
  </div>
</template>

<script>
import StatusChanges from "@/components/status-changes/StatusChanges.vue";
import ChangeStatusTo from "@/components/status-changes/StatusChangeTo.vue";
import CustomerSelect from "@/components/admin/customers/CustomerSelector.vue";
import Order from "@/models/Order.js";
import User from "@/models/User.js";
import StatusSelector from "@/components/status-changes/StatusSelector.vue";
import OrderOperationsMaker from "@/components/user/orders/OrderOperationsMaker.vue";
import HttpClient from "@/models/HttpClient.js";
import Helper from "@/models/Helper.js";
import DatePicker from "@/components/DatePicker.vue";

export default {
  props: ["selectable", "mainPage"],
  data() {
    return {
      selected: [],
      scrollUp: false,
      dialog: false,
      showChanges: false,
      week: null,
      pagination: {
        rowsPerPage: this.getRowsPerPageFromRoute(this.$route.params.per_page),
        sortBy: this.getOrderByFromRoute(this.$route.params.order_by),
        descending: this.getOrderFromRoute(this.$route.params.order),
      },
      statusChanges: [],
      editedIndex: -1,
      editedItem: {
        offer_id: "",
        production_id: "",
        delivery_date: "",
        status: 0,
        customer_order_number: "",
        manager_email: "",
      },
      defaultItem: {
        offer_id: "",
        production_id: "",
        delivery_date: "",
        status: 0,
        customer_order_number: "",
        manager_email: "",
      },
      orders: [],
      filter: this.getFilterFromRoute(this.$route.params.filter),
      deliveryDateFrom: this.getDeliveryDateFrom(
        this.$route.params.delivery_date_from
      ),
      deliveryDateTo: this.getDeliveryDateTo(
        this.$route.params.delivery_date_to
      ),
      perPage: [20, 25, 30, 40, 50, 100], //selection per page
      rows: 20, //default rows
      statusFrom: this.getStatusFromFromRoute(this.$route.params.status_from),
      statusTo: this.getStatusToFromRoute(this.$route.params.status_to),
      selectedOrder: null,
      pages: 1,
      page: this.getPageFromRoute(this.$route.params.page),
      loading: false,
      statusNames: this.$session.get("statusNames").filter((e) => {
        return e.table_name == "orders";
      }),
      statusRights: this.$session.get("statusRights"),
      async: true,
      isChangingFilter: false,
      isChangingWeek: false,
      filterTimer: 0,
      weekTimer: 0,
      user: new User(this.$session.get("user")),
      client: new HttpClient(),
      headers: [],
    };
  },

  computed: {
    isSelectable() {
      return this.selectable;
    },

    ordersSelected() {
      return this.selected.length == 0;
    },

    isAdmin() {
      return this.user["type"] in [0, 1];
    },

    formType() {
      return this.editedIndex === -1;
    },

    formTitle() {
      return this.editedIndex === -1
        ? this.$t("orders_crud.new_order")
        : this.$t("orders_crud.edit_order");
    },

    tableName() {
      return "order";
    },

    descending() {
      if (this.pagination.descending == null) {
        return "ASC";
      }
      return this.pagination.descending ? "DESC" : "ASC";
    },

    sortBy() {
      if (this.pagination.sortBy == null) {
        return "null";
      }
      return this.pagination.sortBy;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    pagination: {
      handler() {
        if (this.mainPage) {
          this.redirect();
        }
        this.initialize();
      },
      deep: true,
    },
    selected() {
      this.$emit("selectedOrders", this.selected);
    },
    isChangingFilter(val) {
      if (!val) {
        this.search();
      }
    },
    filter() {
      clearTimeout(this.filterTimer);
      this.filterTimer = setTimeout(() => {
        this.isChangingFilter = false;
      }, 500);
      if (this.filter == "") {
        this.filter = null;
      }
      this.redirect();
    },
    isChangingWeek(val) {
      if (!val) {
        this.search();
      }
    },
    week() {
      clearTimeout(this.weekTimer);
      this.weekTimer = setTimeout(() => {
        this.isChangingWeek = false;
      }, 500);
      if (this.week == "") {
        this.week = null;
      }
    },
    deliveryDateFrom(val) {
      this.redirect();
      this.deliveryDateTo = val;
      this.initialize();
    },
    deliveryDateTo(val) {
      this.redirect();
      if (val < this.deliveryDateFrom) {
        this.deliveryDateFrom = val;
      }
      this.initialize();
    },
    statusFrom() {
      this.redirect();
      this.initialize();
    },
    statusTo() {
      this.redirect();
      this.initialize();
    },
    page() {
      this.redirect();
    },
  },

  created() {
    this.headers = getHeaders(this);
    this.initialize();
  },

  methods: {
    /**
     * searches the database for orders by given parameters
     */
    async initialize() {
      this.loading = true;
      try {
        const response = await this.client.instance.get("orders", {
          params: getParameters(this),
        });
        if (response.status == 200) {
          this.pages = response.data.last_page;
          this.totalRows = response.data.total;
          this.orders = Order.getOrdersArray(response.data.data);
          this.alreadyFiltered = true;
          this.loading = false;
          if (this.scrollUp) {
            window.scrollTo(0, 0);
            this.scrollUp = false;
          }
        }
      } catch {
        alert(this.$t("orders_crud.get_error"));
        this.orders = [];
        this.loading = false;
      }
      await Helper.timeout(50);
      this.clearSelected();
    },

    savePerPage() {
      localStorage.setItem("orders-per-page", this.pagination.rowsPerPage);
    },

    changeSortBy(header) {
      if (this.pagination.sortBy == header.value) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = header.value;
      }
    },

    clearSelected() {
      this.selected = [];
      const mainCheckbox = document.getElementById("orders-checkbox");
      const checkboxes = document.getElementsByClassName("order-checkbox");
      mainCheckbox.checked = false;
      for (const checkbox of checkboxes) {
        checkbox.checked = false;
      }
    },

    selectAllOrders(event) {
      const checkboxes = document.getElementsByClassName("order-checkbox");
      for (const order of this.orders) {
        this.selectOrder(event, order);
      }
      for (const checkbox of checkboxes) {
        checkbox.checked = event.target.checked;
      }
    },

    selectOrder(event, order) {
      if (event.target.checked) {
        this.addSelected(order);
      } else {
        this.removeSelected(order);
      }
    },

    addSelected(newOrder) {
      const found = this.selected.find((order) => {
        return order.id === newOrder.id;
      });
      if (!found) {
        this.selected.push(newOrder);
      }
    },

    removeSelected(newOrder) {
      const palletIndex = this.selected.indexOf(newOrder);
      if (palletIndex != -1) {
        this.selected.splice(palletIndex, 1);
      }
    },

    /**
     * gets status from rom router link
     * @param statusFrom
     */
    getStatusFromFromRoute(statusFrom) {
      if (statusFrom == null) {
        return 0;
      }
      return parseInt(statusFrom);
    },

    /**
     * gets status to from router link
     * @param statusTo
     */
    getStatusToFromRoute(statusTo) {
      if (statusTo == null) {
        return 100;
      }
      return parseInt(statusTo);
    },

    /**
     * gets rows per page from route
     * @param perPage
     */
    getRowsPerPageFromRoute(perPage) {
      if (perPage == null) {
        return 50;
      }
      return parseInt(perPage);
    },

    /**
     * gets order from route
     * @param order
     */
    getOrderFromRoute(order) {
      if (order == null) {
        return false;
      }
      if (order == "ASC") {
        return false;
      } else {
        return true;
      }
    },

    getOrderByFromRoute(orderBy) {
      if (orderBy == "null") {
        return "production_id";
      }
      if (orderBy == null) {
        return "production_id";
      }
      return orderBy;
    },

    getOrderText(text){
      if(!text){
        return "-"
      }
      return text;
    },

    /**
     * gets page from route
     * @param page
     */
    getPageFromRoute(page) {
      if (page == null) {
        return 1;
      }
      return parseInt(page);
    },

    /**
     * gets filter from router
     * @param filter
     */
    getFilterFromRoute(filter) {
      if (typeof filter == "string" && filter == "null") {
        return null;
      }
      if (filter == null) {
        return null;
      }
      return filter;
    },

    /**
     * gets delivery date from from router
     * @param deliveryDateFrom
     */
    getDeliveryDateFrom(deliveryDateFrom) {
      if (typeof deliveryDateFrom == "string" && deliveryDateFrom == "null") {
        return null;
      }
      if (deliveryDateFrom == null) {
        return null;
      }
      return deliveryDateFrom;
    },

    /**
     * gets delivery date to from router
     * @param deliveryDateTo
     */
    getDeliveryDateTo(deliveryDateTo) {
      if (typeof deliveryDateTo == "string" && deliveryDateTo == "null") {
        return null;
      }
      if (deliveryDateTo == null) {
        return null;
      }
      return deliveryDateTo;
    },

    /**
     * changes status filters
     */
    changeStatusFilters(statuses) {
      this.statusFrom = statuses.status_from != null ? statuses.status_from : 0;
      this.statusTo = statuses.status_to != null ? statuses.status_to : 100;
    },

    /**
     * refresh window after launching into production
     */
    productionSaved() {
      this.selected = [];
      this.initialize();
    },

    /**
     * sends a new order to the database
     *
     * @param order - order data
     */
    async addOrder(order) {
      try {
        await Order.create(formData(order));
        this.initialize();
      } catch {
        alert(this.$t("orders_crud.post_error"));
      }
    },

    /**
     * updates order in the database
     *
     * @param order - given order item
     */
    async editOrder(order) {
      try {
        await order.update(formData(order));
        this.initialize();
      } catch {
        alert(this.$t("orders_crud.update_error"));
      }
    },

    /**
     * deletes item
     *
     * @param item - selected order
     */
    async deleteOrder(order) {
      if (!this.user.hasRights("OP_DEL")) {
        alert(this.$t("orders_crud.no_right_to_delete"));
        return 0;
      }
      const confirmed = confirm(this.$t("orders_crud.delete_confirm"));
      if (!confirmed) {
        return;
      }
      try {
        await order.remove();
        this.initialize();
      } catch {
        alert(this.$t("orders_crud.delete_error"));
      }
    },

    async deleteOrders() {
      if (!this.user.hasRights("OP_DEL")) {
        alert(this.$t("orders_crud.no_right_to_delete"));
        return 0;
      }
      const confirmed = confirm(this.$t("orders_crud.delete_orders_confirm"));
      if (!confirmed) {
        return;
      }
      try {
        this.loading = true;
        await Order.removeOrders(this.selected);
        this.initialize();
      } catch {
        alert(this.$t("orders_crud.delete_orders_error"));
      }
    },
    /**
     * redirect to product
     */
    openProducts(productId) {
      this.$router
        .push({
          path: `/${this.$router.currentRoute.params.lang}/products/${productId}`,
        })
        .catch(() => {});
    },
    /**
     * sets customer id
     *
     * @param customerId
     */
    setCustomer(customerId) {
      this.editedItem["customer_id"] = customerId;
    },
    /**
     * sets contact id
     * @param contactId
     */
    setContact(contactId) {
      this.editedItem["contact_id"] = contactId;
    },
    /**
     * sets address id
     * @param addressId
     */
    setAddress(addressId) {
      this.editedItem["delivery_address"] = addressId;
    },
    /**
     * gets a round number of total area
     */
    roundArea(numb) {
      return parseFloat(Math.round(numb * 100) / 100).toFixed(2);
    },

    /**
     * closes status history
     */
    closeStatuses() {
      if (!this.showChanges) {
        this.statusChanges = [];
      }
    },

    /**
     * opens edit for current item
     *
     * @param item - selected order
     */
    editItem(item) {
      this.editedIndex = this.orders.indexOf(item);
      if (!this.user.hasRights("OP_EDIT") && this.editedIndex != -1) {
        alert(this.$t("orders_crud.no_right_to_edit_order"));
        return 0;
      }
      this.editedItem = Object.create(item);
      this.dialog = true;
    },

    /**
     * closes the dialog
     */
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
      // this.$refs.customerSelect.clearValues();
    },

    /**
     * saves new order to the database by given data
     */
    save() {
      this.addOrder(this.editedItem);
      this.close();
    },

    /**
     * edits selected order in the database by given data
     */
    edit() {
      this.editOrder(this.editedItem);
      this.close();
    },

    /**
     * sets page to 1 and initializes
     */
    search() {
      this.page = 1;
      this.initialize();
    },

    /**
     * clears the filters
     */
    reset() {
      this.$router
        .push({
          path: `/${this.$router.currentRoute.params.lang}/orders`,
        })
        .catch(() => {});
      this.$router.go();
    },

    /**
     * create dispatch and add this order to it
     * @param order
     */
    async planDispatch(order) {
      if (order.pal_status < 1) {
        await this.client.instance.put(`orders/${order.id}`, {
          pal_status: 1,
        });
      }
      if (order.pal_status == 3) {
        localStorage.setItem("showDispatched", true);
      }
      this.$router.push({
        name: "pallet-planning",
        params: { filter: order.toString() },
      });
    },

    /**
     * creates new truck
     * adds pallets that are not assigned to any other truck to this truck
     * opens truck page, with selected orders loaded
     */
    async planDispatchForOrders() {
      let orders = this.selected.slice();
      let updatingOrders = [];
      let filter = "";
      orders.forEach((order, i) => {
        filter += order.toString();
        if (this.selected.length != 0 && this.selected.length - 1 != i) {
          filter += ", ";
        }
        if (order.pal_status < 1) {
          updatingOrders.push({
            id: order.id,
            pal_status: 1,
          });
        }
        if (order.pal_status == 3) {
          localStorage.setItem("showDispatched", true);
        }
      });
      if (updatingOrders.length > 0) {
        await this.client.instance.put("orders", { orders: updatingOrders });
      }
      this.$router.push({
        name: "pallet-planning",
        params: { filter: filter },
      });
    },

    changeDate(event, key) {
      if (this.$refs.datePicker) {
        this.$refs.datePicker.open(event, key);
      }
    },

    selectDate(date, key) {
      this[key] = date;
    },

    /**
     * paginates the page
     */
    paginate() {
      this.scrollUp = true;
      this.initialize();
    },

    /**
     * changes router link
     */
    redirect() {
      const filter =
        this.filter != null && this.filter.length > 0 ? this.filter : null;
      const deliveryDateFrom =
        this.deliveryDateFrom != null ? this.deliveryDateFrom : null;
      const deliveryDateTo =
        this.deliveryDateTo != null ? this.deliveryDateTo : null;
      const perPage =
        this.pagination.rowsPerPage != null ? this.pagination.rowsPerPage : 50;
      const page = this.page != null ? this.page : 1;
      const orderBy =
        this.pagination.sortBy != null ? this.pagination.sortBy : "null";
      const order =
        this.pagination.descending != null
          ? this.pagination.descending
            ? "DESC"
            : "ASC"
          : null;
      if (this.mainPage) {
        this.$router
          .replace({
            path: `/${this.$router.currentRoute.params.lang}/orders/${filter}/${deliveryDateFrom}/${deliveryDateTo}/${this.statusFrom}/${this.statusTo}/${perPage}/${page}/${orderBy}/${order}`,
          })
          .catch(() => {});
      }
    },

    async openOperationsMaker() {
      if (this.$refs.orderOperationsMaker) {
        this.$refs.orderOperationsMaker.open(this.selected);
      }
    },

    getLocale() {
      return Helper.getLocale(this);
    },
  },

  components: {
    DatePicker,
    StatusChanges,
    ChangeStatusTo,
    CustomerSelect,
    StatusSelector,
    OrderOperationsMaker,
  },
};

function getHeaders(vue) {
  const headers = [
    {
      text: vue.$t("orders_crud.production_id"),
      align: "left",
      sortable: true,
      value: "production_id",
      width: 10,
    },
    {
      text: vue.$t("orders_crud.offer_id"),
      align: "left",
      value: "offer_id",
      sortable: true,
      width: 10,
    },
    {
      text: vue.$t("orders_crud.customer"),
      align: "left",
      sortable: true,
      value: "customer",
      width: 15,
    },
    {
      text:
        vue.user.company_id != 7
          ? vue.$t("orders_crud.delivery_date")
          : vue.$t("orders_crud.week"),
      align: "left",
      value: "delivery_date",
      width: 8,
      sortable: true,
    },
    {
      text: vue.$t("orders_crud.type"),
      align: "left",
      sortable: false,
      value: "product_type",
      width: 5,
    },
    {
      text: vue.$t("orders_crud.products_count"),
      align: "left",
      sortable: false,
      value: "count",
      width: 5,
    },
    {
      text: vue.$t("orders_crud.products_area"),
      align: "left",
      sortable: false,
      value: "area",
      width: 5,
    },
    {
      text: vue.$t("orders_crud.customer_order_number"),
      align: "left",
      sortable: false,
      value: "customer_order_number",
      width: 10,
    },
    {
      text: vue.$t("orders_crud.manager_email"),
      align: "left",
      sortable: false,
      value: "manager_email",
      width: 10,
    },
    {
      text: vue.$t("orders_crud.status"),
      align: "left",
      value: "status",
      sortable: true,
      width: 5,
    },
    {
      text: vue.$t("orders_crud.actions"),
      align: "left",
      sortable: false,
      width: 10,
    },
  ];
  if (vue.user.company_id == 7) {
    headers.splice(headers.length - 1, 0, {
      text: "Adresas",
      align: "left",
      sortable: false,
    });
  }

  return headers;
}

function formData(order) {
  let data = {
    status: order["status"],
  };
  if (order["offer_id"] != null) data["offer_id"] = order["offer_id"];
  if (order["production_id"] != null)
    data["production_id"] = order["production_id"];
  if (order["delivery_date"] != null)
    data["delivery_date"] = order["delivery_date"];
  if (order["customer_id"] != null) data["customer_id"] = order["customer_id"];
  if (order["contact_id"] != null) data["contact_id"] = order["contact_id"];
  if (order["delivery_address"] != null)
    data["delivery_address"] = order["delivery_address"];
  if (order["customer_order_number"])
    data["customer_order_number"] = order["customer_order_number"];
  if (order["manager_email"]) data["manager_email"] = order["manager_email"];
  return data;
}
/**
 * selects all the parameters for filtering
 */
function getParameters(vue) {
  let params = {
    rows: vue.pagination.rowsPerPage,
    order_by: vue.sortBy,
    order: vue.descending,
    page: vue.page,
    week: getFilterWeek(vue.week),
  };
  if (vue.filter != null && vue.filter.length != 0)
    params["filter"] = vue.filter;
  if (vue.deliveryDateFrom != null)
    params["delivery_date_from"] = vue.deliveryDateFrom;
  if (vue.deliveryDateTo != null)
    params["delivery_date_to"] = vue.deliveryDateTo;
  if (vue.statusFrom != null) params["status_from"] = vue.statusFrom;
  if (vue.statusTo != null) params["status_to"] = vue.statusTo;
  return params;
}
function getFilterWeek(week) {
  if (week) {
    const firstChar = week.substring(0, 1);
    if (week.length == 3 && firstChar.toLowerCase() == "w") {
      const date = new Date();
      const year = date.getFullYear();
      return `${year}${week.substring(1, 3)}`;
    }
    if (week.length == 6) {
      return week;
    }
    return null;
  }
  return null;
}
</script>

<style scoped>
.table_title {
  width: 10%;
}
.icons {
  width: 150px;
}
table.v-table tbody td,
table.v-table tbody th {
  height: 10px;
}
</style>
